'use strict';

angular.module('internal.admin')
    .controller('InternalAdminEnterpriseDataChangeLog', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    }])
;